<template>
  <v-dialog
    :model-value="modelValue"
    content-class="confirm-remove-modal"
    transition="scale-transition"
    :scrim="'#212121'"
    :opacity="0.45"
    @click:outside="closeDialog"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="pa-5 dialog confirm-remove-modal confirm-remove-modal__card">
      <v-card-title class="d-flex justify-end pa-0">
        <v-btn
          class="ms-n1 me-1"
          icon
          variant="flat"
          @click="closeDialog"
        >
          <icon height="14" width="14">close-x</icon>
        </v-btn>
      </v-card-title>
      <h3 class="flex-grow-1 text-center mb-2">
        Are You Sure?
      </h3>
      <v-card-text class="px-0 text-center">
        Do you want to remove this item from your cart? If not, click ‘Cancel’
      </v-card-text>
      <v-btn
        class="mb-3 confirm-remove-modal__btn"
        color="primary"
        size="large"
        variant="flat"
        rounded
        width="100%"
        @click="$emit('confirm')"
      >
        Remove Item
      </v-btn>
      <v-btn
        class="cancel-btn confirm-remove-modal__btn"
        color="surface-variant"
        size="large"
        variant="outlined"
        rounded
        width="100%"
        @click="closeDialog"
      >
        Cancel
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmRemove',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'close-dialog', 'confirm'],
  methods: {
    closeDialog() {
      this.$emit('update:modelValue', false);
      this.$emit('close-dialog');
    }
  }
};
</script>

<style lang="scss" scoped>
  .v-btn--icon.v-btn--density-default {
    width: 32px;
    height: 32px;
  }
  :deep(.v-card-text) {
    color: rgba(0, 0, 0, .6) !important;
    padding-top: 6px !important;
    padding-bottom: 20px !important;
    font-size: 0.875rem !important;
  }

	.v-dialog {
		width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
		width: 100%;
	}

	.confirm-remove-modal {  
	  &__card {
		max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
		max-height: 94%;
		margin: 0;
		border-radius: 2rem !important;
	  }

    h3 {  
      font-size: 1.25rem !important;
      line-height: 1.5625rem!important;
      margin-bottom: 2px !important;
    }
	}

	:deep(.v-overlay__content) {  
	  max-height: calc(100vh - 48px);
	  max-width: min(480px, calc(100vw - 48px));
	}

  .confirm-remove-modal__btn {
    font-size: 0.875rem !important;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    min-height: 40px !important;
    height: 40px !important;
  }

  .cancel-btn {
    color: rgba(0,0,0, 1) !important;
  }
</style>
